import React, { useMemo } from 'react';
import useTheme from 'branding/theme';
import Span from '../../typography/Span';
import CaretIcon from '../../icons/utility/CaretIcon';
const ItemBody = ({ children, isWarning = false, description, infoText, showCaret = true }) => {
    const { typography, colors } = useTheme();
    const coreStyles = description
        ? {
            marginTop: '-1.2rem',
            marginBottom: '-1.2rem'
        }
        : {};
    const mainTextStyles = useMemo(() => ({
        ...typography.strong,
        whiteSpace: 'nowrap'
    }), [typography]);
    const supplementaryStyles = {
        ...coreStyles,
        display: 'flex',
        alignItems: 'center'
    };
    const descriptionStyles = useMemo(() => ({
        display: 'block',
        ...(isWarning && { color: colors.status.fail.alpha })
    }), [isWarning, colors]);
    const caretStyles = useMemo(() => ({
        marginLeft: '2rem'
    }), []);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: coreStyles },
            React.createElement(Span, { styles: mainTextStyles }, children),
            description && React.createElement(Span, { styles: descriptionStyles }, description)),
        React.createElement("div", { style: supplementaryStyles },
            infoText && React.createElement(Span, null, infoText),
            showCaret && React.createElement(CaretIcon, { styles: caretStyles, size: "small" }))));
};
export default ItemBody;
//# sourceMappingURL=ItemBody.js.map